import * as _ from 'underscore';
import { shallowEqual } from 'react-redux';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const createDeepEqualSelector = createSelectorCreator(
    defaultMemoize,
    _.isEqual
);

export const createShallowEqualSelector = createSelectorCreator(
    defaultMemoize,
    shallowEqual
);
